/* ==========================================================================
   FreezeCap™ — fc-main-blog.liquid wiring (extracted in v6.30)
   --------------------------------------------------------------------------
   Tag-chip filter on the blog index. Click a chip, the grid hides every
   card whose data-tag doesn't match (or shows everything for "all").
   No Liquid interpolation.
   ========================================================================== */
(function () {
  function init() {
    var filter = document.querySelector('[data-fc-filter]');
    var grid   = document.querySelector('[data-fc-grid]');
    if (!filter || !grid) return;

    var chips = filter.querySelectorAll('[data-fc-filter-chip]');
    var cards = grid.querySelectorAll('[data-fc-article-card]');

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var target = chip.getAttribute('data-fc-filter-chip');
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        cards.forEach(function (card) {
          if (target === 'all' || card.getAttribute('data-tag') === target) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
